<ul class="inline-ul">
  <li *ngIf="customerLogo" class="logo customer-logo-li">
  <img class="customer-logo" [src]='customerLogo' (click)="this.router.navigate([this.crystalClearFrontUrl.HOME.path])"/></li>
  <li class="logo cc-logo" (click)="this.router.navigate([this.crystalClearFrontUrl.HOME.path])">
      <span class="logo-img out"></span>
      <div>
<!--      <span class="name-img">-->
<!--        <div class="part1">CRYSTAL</div>-->
<!--        <div class="part2">CLEAR</div>-->
<!--      </span>-->
        <ng-template [ngIf]="customerName&&customerName.length>0">
          <span class="separator">|</span>
          <span class="customer-name">{{customerName}}</span>
        </ng-template>
        <!--        <span class="separator">|</span>-->
        <!--        <span class="customer-name">Tullet Prebon</span>-->
    </div>
    <!--    <div>-->
    <!--      <span class="name-img"></span>-->
    <!--      <span class="customer-name"></span>-->
    <!--    </div>-->
  </li>
</ul>
<!--<ul class="inline-ul">-->
<!--  <li class="logo">-->
<!--        <span (click)="go(HeaderWithMenuComponent.Menu.TRADESORDERS)"-->
<!--              class="logo-img out"></span>-->
<!--    <div>-->
<!--      <span class="name-img"></span>-->
<!--    </div>-->
<!--  </li>-->
<!--</ul>-->
